'use strict';

const { max } = require("lodash");

const targetElement = $("ul.product-content-item-list");

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
 function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [

        //'.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.refinements',
        '.product-content-item-count',
        '.product-content-tag-list'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    $('body').removeClass('noScroll');

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
    //filter.jsのメソッド再実行
    window.globalFunction.initFilterListHover();
    window.globalFunction.initMobileFilter();
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

module.exports = {
    // LazyLoad用イベント
    showMore: function () {
        $(window).on("load", function () {

            // LazyLoad後に画面更新・別画面から戻った場合に強制スクロールしてしまうためスクロール履歴削除
            history.scrollRestoration = "manual";
            $(window).scrollTop(0);
        });

        $(window).scroll(function () {
            // スクロールが停止したときに処理開始
            clearTimeout($.data(this, "scrollTimer"));
            $.data(
                this,
                "scrollTimer",
                setTimeout(function () {
                    // ターゲット要素の底までスクロールしたか判定
                    if (
                        $(this).scrollTop() + $(this).height() >
                        targetElement.offset().top + targetElement.height()
                    ) {
                        const showMoreUrl = $('.show-more').data('url');

                        $.ajax({
                            url: showMoreUrl,
                            data: { selectedUrl: showMoreUrl },
                            method: 'GET',
                            success: function (res) {
                                const $res = $(res);

                                // Product Grid に取得した要素を追加
                                $('.show-more').replaceWith($res.children('li'));

                                // ページのアイテム数を更新
                                const pageCount = $res.data('page-count');
                                $('.product-content-item-count').text(pageCount);

                            },
                            error: function (req, status, error) {
                            },
                        });
                    }
                }, 250)
            );
        });
    },

    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('.container').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            let sortingUrl = this.value;
            if (sortingUrl && $('input[name="coming_soon"]').length) {
                sortingUrl += '&coming_soon=true';
            }
            $.spinner().start();
            $(this).trigger('search:sort', sortingUrl);

            $.ajax({
                url: sortingUrl,
                data: { selectedUrl: sortingUrl },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle sort order menu selection
        $('.container').on('click', '.jsSwitchCheckbox, .jsCheckbox , .filter-radio', function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                var attributeId = '#' + $(this).find('span').last().attr('id');
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                        $(attributeId).parent('input').focus();
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent('input').focus();
                    }
                });

            });
    },

    removeTag: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.product-content-tag-list li',
            function (e) {
                console.log('remove tag');
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href'),
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href')
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showClickedTab: function () {

        $('.container').on('click', '.product-search', function () {
            const $navItems = $('.nav-item');
            const $toggleContents = $('.jsTabToggleContent');

            $navItems.each(function (index) {
                const $this = $(this);
                $this.data('index', index);


                $this.click(function () {
                    const $clicked = $(this);
                    const index = $clicked.data('index');

                    if (!$clicked.hasClass('active')) {
                        $navItems.removeClass('active');
                        $toggleContents.removeClass('active');

                        $clicked.addClass('active');
                        $toggleContents.eq(index).addClass('active');
                    }
                });
            });
        });

    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    //filter by input text
    textFilter: function () {
        $('.container').on(
            'keydown',
            '.filterText',
            function (e) {
                var self = this;
                var searchText = self.value.toLowerCase();

                if (searchText === '') {
                    $(this).parent().parent().find('li').each(function () {
                        $(this).show();
                    });
                } else {
                    $(this).parent().parent().find('li').each(function () {
                        var value = $(this).attr('id').toLowerCase();

                        if (!value || value.indexOf(searchText) > -1) {
                            $(this).show();
                        } else {
                            $(this).hide();
                        }

                    });
                }
            }
        );
    },

    //filter by min-max price
    priceFilter: function () {
        $('.container').on(
            'click',
            '#price-filter',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var minPrice = $('#min-price').val();
                var maxPrice = $('#max-price').val();
                var maxPriceValidate = $('#max-price-valid').val();
                var minPriceValidate = $('#min-price-valid').val();
                var priceUrl = '';

                $.spinner().start();

                $('.input__price-error').text('');

                // required error
                if(!minPrice && !maxPrice){
                    $('.input__price-error').text('One of the fields is required.');
                    $.spinner().stop();
                    return;
                }

                // invalid error
                if(minPrice && maxPrice){
                    if (Number(minPrice) > Number(maxPrice)) {
                        $('.input__price-error').text('Invalid value.');
                        $.spinner().stop();
                        return;
                    }
                }

                // range value error
                if(minPrice && Number(minPrice) > Number(maxPriceValidate)) {
                    $('.input__price-error').text('There are no products corresponding to the amount entered.');
                    $.spinner().stop();
                    return;
                }

                if(maxPrice && Number(maxPrice) < Number(minPriceValidate)) {
                    $('.input__price-error').text('There are no products corresponding to the amount entered.');
                    $.spinner().stop();
                    return;
                }

                if (minPrice) {
                    priceUrl = '&pmin=' + minPrice;
                }

                if (maxPrice) {
                    priceUrl += '&pmax=' + maxPrice;
                }


                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href') + priceUrl + '&isRangePrice=true',
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href') + priceUrl + '&isRangePrice=true'
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },

    //filter by min-max price
    priceFilterSp: function () {
        $('.container').on(
            'click',
            '#price-filter-sp',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var minPrice = $('#min-price-sp').val();
                var maxPrice = $('#max-price-sp').val();
                var maxPriceValidate = $('#max-price-valid').val();
                var minPriceValidate = $('#min-price-valid').val();
                var priceUrl = '';

                $.spinner().start();

                $('.input__price-error-sp').text('');

                // required error
                if(!minPrice && !maxPrice){
                    $('.input__price-error-sp').text('One of the fields is required.');
                    $.spinner().stop();
                    return;
                }

                // invalid error
                if(minPrice && maxPrice){
                    if (Number(minPrice) > Number(maxPrice)) {
                        $('.input__price-error-sp').text('Invalid value.');
                        $.spinner().stop();
                        return;
                    }
                }

                // range value error
                if(minPrice && Number(minPrice) > Number(maxPriceValidate)) {
                    $('.input__price-error-sp').text('There are no products corresponding to the amount entered.');
                    $.spinner().stop();
                    return;
                }

                if(maxPrice && Number(maxPrice) < Number(minPriceValidate)) {
                    $('.input__price-error-sp').text('There are no products corresponding to the amount entered.');
                    $.spinner().stop();
                    return;
                }

                if (minPrice) {
                    priceUrl = '&pmin=' + minPrice;
                }

                if (maxPrice) {
                    priceUrl += '&pmax=' + maxPrice;
                }


                $(this).trigger('search:filter', e);
                $.ajax({
                    url: $(this).data('href') + priceUrl + '&isRangePrice=true',
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: $(this).data('href') + priceUrl + '&isRangePrice=true'
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },
    // prevent submit event if the search input is empty
    preventSubmitIfEmpty: function () {
        $('.input__search-form').on('submit', 'form', function (e) {
            var $input = $(this).find('input[name=q]');
            if (!$input.val() || $input.val().trim().length === 0) {
                e.preventDefault();
            }
        });
    }
};
